import { fromJS } from 'immutable'
import {
  POSITION_LIST_REQUEST,
  POSITION_LIST_SUCCESS,
  POSITION_LIST_FAILURE,
  POSITION_LIST_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case POSITION_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case POSITION_LIST_SUCCESS:
      if (action.payload.ok) {
        return state
          .set('isFetching', false)
          .set('position', fromJS(action.payload.positions))
          .set('status', action.payload.ok)
      }
      return state
        .set('isFetching', false)
    case POSITION_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case POSITION_LIST_RESET:
      return state
        .set('redirect', false)
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/position/position-list-reducer.js